import React from 'react';
import { useGoogleLogin } from '@react-oauth/google';
import { useDispatch } from 'react-redux';
import { styled } from '@mui/material/styles';
import { Button, Box } from '@mui/material';
import { requestLoginGoogle, loadUsers } from '../../redux/accountSlice';

const StyledGoogleButton = styled(Button)(({ theme }) => ({
  backgroundColor: '#ffffff',
  color: theme.palette.text.primary,
  border: `1px solid ${theme.palette.divider}`,
  textTransform: 'none',
  padding: theme.spacing(1, 2),
  '&:hover': {
    backgroundColor: theme.palette.grey[50],
  },
  gap: theme.spacing(1),
  marginBottom: theme.spacing(2),
}));

const GoogleIcon = styled('img')({
  width: 20,
  height: 20,
});

const GoogleSignInButton = () => {
  const dispatch = useDispatch();
  
  const handleGoogleSuccess = async (tokenResponse) => {
    
    try {
      const baseUrl = process.env.REACT_APP_HOST && process.env.REACT_APP_PORT
            ? `${process.env.REACT_APP_HOST}:${process.env.REACT_APP_PORT}/api/`
              : 'http://localhost:3000/api/';
      const backendResponse = await fetch(`${baseUrl}account/google/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ token: tokenResponse.access_token }),
      });

      const data = await backendResponse.json();

      dispatch(requestLoginGoogle({ user: data.user, token: data.token }));
      // Load users after successful Google login
      dispatch(loadUsers());
    } catch (error) {
      console.error('Erro ao autenticar com o back-end:', error);
    }
  };

  const login = useGoogleLogin({
    onSuccess: handleGoogleSuccess,
    onError: error => console.error('Erro de login no Google:', error),
  });

  return (
    <StyledGoogleButton onClick={() => login()} fullWidth>
      <GoogleIcon src="https://upload.wikimedia.org/wikipedia/commons/thumb/c/c1/Google_%22G%22_logo.svg/1200px-Google_%22G%22_logo.svg.png" alt="Google logo" />
      <Box>Entrar com o Google</Box>
    </StyledGoogleButton>
  );
};

export default GoogleSignInButton;